import { render, staticRenderFns } from "./PlgApiLogs.vue?vue&type=template&id=f6112e1a&"
import script from "./PlgApiLogs.vue?vue&type=script&lang=js&"
export * from "./PlgApiLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports